import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=0b5eacc0&scoped=true&lang=html&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5eacc0",
  null
  
)

export default component.exports